module.exports = __webpack_public_path__ + "img/wm-system-demo3.56b3b60b.png";